import {FORECAST_ORDER_LOADED} from "./ActionType";

export default function forecastOrderReducer(state = [], action) {
  const {type, payload} = action;

  switch (type) {
    case FORECAST_ORDER_LOADED:
      return (state = payload);
      
    default:
      return state;
  }
}
